// An entityContext holding an entity TYPE, not a declared context NAME, is
// ambient: the host supplies it everywhere, so there is nothing to repoint.
function isAmbientContextName(name, legacyEntities) {
  if (!name) {
    return false;
  }
  const entities = legacyEntities ?? {};
  return Boolean(entities[name] ?? entities[String(name).replace(/^Legacy/, "")]);
}

function readLegacyEntities() {
  if (typeof window === "undefined") {
    return {};
  }
  return window.blclient?.data?.legacyEntities ?? {};
}

module.exports = { isAmbientContextName, readLegacyEntities };
